 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-0006a431":"1cf74aa5","chunk-0132f376":"93e8b4ee","chunk-04d459c1":"29704bea","chunk-0900ddec":"d41c3bcf","chunk-093f272e":"72fb6b9c","chunk-0ebca02a":"2d23004f","chunk-13817cd5":"4f132378","chunk-1da7959b":"709fdfce","chunk-2206f8a6":"cc94f9a1","chunk-2207d67a":"85b1f054","chunk-2be4766a":"d9e21567","chunk-2d0a463b":"2c126ba6","chunk-2d0abe2a":"5422ce8e","chunk-2d0ac931":"2fe6e773","chunk-2d0bdb18":"c2ae1cae","chunk-2d0bdf09":"fe0ce4f6","chunk-2d0be6d7":"191b599a","chunk-2d0c073f":"15cc080b","chunk-2d0c09db":"8a124a2f","chunk-2d0c211b":"b32d6e95","chunk-2d0c7312":"9abe193a","chunk-2d0c8407":"9dd5d909","chunk-2d0c8871":"d0d7b656","chunk-2d0cf315":"d55b4fcd","chunk-2d0cf9fe":"19e97b5a","chunk-2d0d3c84":"dc2ba6c0","chunk-2d0d43da":"b5b6c4cb","chunk-2d0d6793":"9f0974b4","chunk-2d0d6966":"328b2108","chunk-2d0d6bbc":"48fd7461","chunk-2d0d6d65":"8d87704d","chunk-2d0d78b2":"78f1259e","chunk-2d0d9f47":"3737b81c","chunk-2d0da04a":"ded40908","chunk-2d0de03d":"9dd40dd5","chunk-2d0e2170":"abdc54d3","chunk-2d0e57f4":"1441bd19","chunk-2d0e5812":"3ab77812","chunk-2d0e9381":"6b7bfdd1","chunk-2d0f064c":"1fde24be","chunk-2d2080c7":"50a0b2f1","chunk-2d20f517":"25a5469d","chunk-2d213189":"ac95dbbe","chunk-2d216214":"cc0b784f","chunk-2d216257":"9bfc141b","chunk-2d216786":"19465ff4","chunk-2d216a01":"7a5c48d8","chunk-2d217def":"1c58d337","chunk-2d218068":"1fa68658","chunk-2d21a9aa":"d5bbdfe6","chunk-2d21d677":"378298e4","chunk-2d222064":"aca585e0","chunk-2d222cca":"79c1b717","chunk-2d22895d":"c96a8e7c","chunk-2d230c96":"3325ae0d","chunk-2d23721e":"1875003a","chunk-30a9a89d":"8396cfc9","chunk-3106975e":"df89b551","chunk-32cf1849":"c1c3ca84","chunk-4261ce5e":"7ac0880a","chunk-431e8a38":"77c12b20","chunk-4570997a":"b3984bee","chunk-4b53e668":"35b6ad95","chunk-4ee2b46f":"6268e389","chunk-50a18636":"4e82d531","chunk-540a2426":"6c100d49","chunk-56eefa71":"176f0f0b","chunk-59fdc88a":"6e685bfa","chunk-5b0ee2aa":"d0b91ef2","chunk-60d0c2df":"8efaf5cc","chunk-64a0096b":"9acc2cdb","chunk-66463db3":"d0030ecb","chunk-6acb6f6b":"ccbf74e7","chunk-6d22df2d":"22d5499a","chunk-6f61dd68":"4c7ffe9d","chunk-781b512c":"510318ee","chunk-79dd5ac0":"2ec29c41","chunk-85b5d926":"96806589","chunk-86222582":"92b709d1","chunk-900c197e":"57fc6325","chunk-903231d6":"01e18df4","chunk-9099260a":"cf8ed324","chunk-93066ee6":"d0c0face","chunk-93311420":"b67bc9b3","chunk-9c6dd432":"3ff6c904","chunk-b5756354":"b1b41fa7","chunk-bfdbcc14":"58843707","chunk-df1db842":"45fe46e5","chunk-df1eb2d2":"3cefc6ef","chunk-df476974":"4cbea93e","chunk-ea105bb6":"91cff40a","chunk-eacbb13e":"4d8756df","chunk-f29fa758":"6af7d34c","chunk-f93c6b4e":"f24c9561","stencil-polyfills-css-shim":"4df8bec4","stencil-polyfills-dom":"c17d705d","chunk-2d0a3a6a":"9083e201","chunk-2d0d01da":"5069a3e3","chunk-2d215d2b":"4dd6051e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
